import { render, staticRenderFns } from "./Codigos.vue?vue&type=template&id=08830731&scoped=true&"
import script from "./Codigos.vue?vue&type=script&lang=js&"
export * from "./Codigos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08830731",
  null
  
)

export default component.exports